import { PaymentMethod } from "../../Enums/PaymentMethod";
import { OrderPaymentDetailsResponse } from "../../Models/Payment";
import BankingBilletStep from "../BankingBilletStep/BankingBilletStep";
import Modal from "../common/Modal/Modal";
import PixPaymentStep from "../PixPaymentStep/PixPaymentStep";

type PaymentModalProps = {
  isOpen: boolean;
  onClose: () => void;
  paymentMethod: PaymentMethod;
  paymentDetails: OrderPaymentDetailsResponse;
};

const PaymentModal = ({ isOpen, onClose, paymentMethod, paymentDetails }: PaymentModalProps) => {

  if (!isOpen || !paymentDetails) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={"Detalhes do Pagamento"}>
      {paymentMethod === PaymentMethod.Pix && paymentDetails.pix && (
        <PixPaymentStep pixData={paymentDetails.pix} />
      )}

      {paymentMethod === PaymentMethod.BankingBillet && paymentDetails.bankingBillet && (
        <BankingBilletStep
          billetUrl={paymentDetails.bankingBillet.billetLink}
          billetPdf={paymentDetails.bankingBillet.billetPdf}
          expiration={paymentDetails.bankingBillet.expiration}
        />
      )}
    </Modal>
  );
};

export default PaymentModal;
